import { setFontVariant, colorsPalettes } from "@similarweb/styles";
import { FlexColumn, FlexRow } from "@similarweb/ui-components";
import styled, { css } from "styled-components";
const { carbon } = colorsPalettes;

const StyleChartTableTooltipWrapper = styled(FlexRow)``;

export const TooltipContainer = styled(FlexColumn)`
    align-items: start;
    justify-content: center;
    ${setFontVariant("body2")};
    width: 341px;
`;

export const TooltipMarkerName = styled.div`
    max-width: 309px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    ${setFontVariant("body2", carbon[500])}
`;

export const TooltipMarker = styled.div<{
    backgroundColor: string;
    height: string;
    width: string;
}>`
    flex-shrink: 0;
    border-radius: 100%;
    height: ${({ height }) => height};
    width: ${({ width }) => width};
    ${({ backgroundColor }) =>
        css`
            background-color: ${backgroundColor};
        `};
    
  
`;

export const StyledItemWrapper = styled(FlexRow)`
    justify-content: space-between;
    align-items: center;
    width: 100%;
    gap: 10px;
    ${setFontVariant("body2", carbon[500])}

    .custom-change-value {
        ${setFontVariant("body2")}
    }
`;

export const StyledHeader = styled(FlexRow)`
    width: 100%;
    align-items: center;
    justify-content: space-between;
    padding-bottom: 12px;
`;

export const StyledGroup = styled(FlexRow)`
    align-items: center;
    gap: 8px;
`;

export const StyledDomain = styled(FlexRow)`
    align-items: center;
    ${setFontVariant("listItem3", carbon[400])}
`;
export const StyledShare = styled(FlexRow)`
    align-items: center;
    ${setFontVariant("listItem3", carbon[400])}
`;
